import $ from 'jquery';
import clusterImage from "../../images/buyMap/cluster.svg";
import clusterRedImage from "../../images/buyMap/cluster-red.svg";
import mapMarkerImage from "../../images/buyMap/map-marker.png";
import '../../../js/select2-loader';
import UrlBuilder from "../components/urlBuilder"; '../components/urlBuilder';

const $keywords = $('.md-tags-input');

document.addEventListener('livewire:init', () => {

    $(function () {
        /* URL builder */
        const queryArrayParams = [
            "districts",
            "bedrooms",
            "is_sold",
            "view",
            "buildingType",
            "condition",
            "propertytype",
            "ideal",
            "amenity",
            "page",
        ];
        const urlBuilder = new UrlBuilder(queryArrayParams);
        const initFiltersContent = urlBuilder.getStoredFilters();



        /* */

        const $minPriceFilter = $('#minPriceFilter');
        const $minPriceFilterMobile = $('#minPriceFilterMobile');
        const $maxPriceFilter = $('#maxPriceFilter');
        const $maxPriceFilterMobile = $('#maxPriceFilterMobile');
        const $minSizeFilter = $('#minSizeFilter');
        const $minSizeFilterMobile = $('#minSizeFilterMobile');
        const $maxSizeFilter = $('#maxSizeFilter');
        const $maxSizeFilterMobile = $('#maxSizeFilterMobile');
        const $minRoomFilter = $('#minRoomFilter');
        const $minRoomFilterMobile = $('#minRoomFilterMobile');
        const $maxRoomFilter = $('#maxRoomFilter');
        const $maxRoomFilterMobile = $('#maxRoomFilterMobile');

        const $bedroomsFilter = $('.bedroomsFilter');
        const $bathroomsFilter = $('.bathroomsFilter');
        const $viewFilters = $('.viewFilters');
        const $buildingTypeFilters = $('.buildingTypeFilters');
        const $rentalFilters = $('.rentalFilters');
        const $isSoldFilters = $('.isSoldFilters');
        const $conditionFilters = $('.conditionFilters');
        const $propertyTypeFilters = $('.propertyTypeFilters');
        const $idealForFilters = $('.idealForFilters');
        const $hasElevatorFilter = $('.hasElevatorFilter');
        const $amenityFilters = $('.amenityFilters');
        //const $onSaleFilter = $('.onSaleFilter');
        const $clearFilterButton = $("#clear-filter");
        const $navigationModal = $(".navigation-modal ");
        const body = $("body");

        let navigateUrl = "";
        const localStoragePopUpKey= "fondQueryModalHasVisited";

        body.on('click','.fa-search',function(){
            $keywords.select2("open");
        });

        body.on("click",".nav-link",function(event){

            if(!localStorage.getItem(localStoragePopUpKey)){
                event.preventDefault();
                localStorage.setItem(localStoragePopUpKey,true);
                $navigationModal.removeClass("d-none");
                body.addClass("body-no-scroll");
                setTimeout(() => $navigationModal.find(".modal").addClass("show"),10);
                navigateUrl = $(this).attr("href");
            }
        });

        body.on('click','.navigate-modal-close',() => {
            location.href=navigateUrl;
        });

        const showClearFilter = () => {
            if(!!urlBuilder.getStoredFilters()){
                $clearFilterButton.removeClass("d-none");
            }else{
                $clearFilterButton.addClass("d-none");
            }

        };

        const showAtInitFilterArrayItem = (inputKey, id,optionKey = null) => {

            let $checkbox = $(`input[name=${inputKey}\\[\\]][value=${id}]`);
            $checkbox.prop('checked','checked');
            //console.log("Init ",$checkbox.prev().text(),`${optionKey ? optionKey : inputKey}:${id}`)
            addSelectOption(`${optionKey ? optionKey : inputKey}:${id}`,$checkbox.first().prev().text());
        };

        const lookupUrl = $keywords.data('lookup-url');

        const keywordsPlaceholder = $keywords.data('placeholder');
        const locale = $('html').attr('lang');

        const toggleSearchableComponent = (e) => {

            console.log("toggle event ",e);

            if (e.params._type == 'select') {

                console.log($keywords.children());
            }

            let $checkbox;


            var idParts = e.params.data.id.split(':');
            const type = idParts[0];
            console.log("type:",type)
            if (idParts.length === 2) {
                const id = idParts[1];
                switch (type) {
                    case 'district':
                        urlBuilder.updateArrayBaseFilter("districts",id);
                        window.history.pushState({district: id},'','');
                        Livewire.dispatch('districtFilterChanged', {district: id});
                        $checkbox = $(`input[name=districts\\[\\]][value=${id}]`);
                        $checkbox.prop('checked', !$checkbox.is(':checked'));
                        $keywords.find(`option[value="district\:${id}"]`).remove();
                        showClearFilter();
                        break;
                    case 'bedrooms':
                        urlBuilder.updateArrayBaseFilter("bedrooms",id);
                        Livewire.dispatch('bedroomsFilterChange', {bedroomsType: id});
                        $checkbox = $(`input[name=bedrooms\\[\\]][value=${id}]`);
                        $checkbox.prop('checked', !$checkbox.is(':checked'));
                        $keywords.find(`option[value="bedrooms\:${id}"]`).remove();
                        showClearFilter();
                        break;
                    case 'view':
                        urlBuilder.updateArrayBaseFilter("view",id);
                        Livewire.dispatch('viewFilterChanged', {viewSlug: id});
                        $checkbox = $(`input[name=views\\[\\]][value=${id}]`);
                        console.log("here ",$checkbox);
                        $checkbox.prop('checked', !$checkbox.is(':checked'));
                        $keywords.find(`option[value="view\:${id}"]`).remove();
                        showClearFilter();
                        break;
                    case 'buildingType':
                        urlBuilder.updateArrayBaseFilter("buildingType",id);
                        Livewire.dispatch('buildingTypeFilterChanged', {typeName: id});
                        $checkbox = $(`input[name=buildingTypes\\[\\]][value=${id}]`);
                        console.log("here ",$checkbox);
                        $checkbox.prop('checked', !$checkbox.is(':checked'));
                        $keywords.find(`option[value="buildingType\:${id}"]`).remove();
                        showClearFilter();
                        break;
                    case 'condition':
                        urlBuilder.updateArrayBaseFilter("condition",id);
                        Livewire.dispatch('conditionFilterChanged', {conditionSlug: id});
                        $checkbox = $(`input[name=conditions\\[\\]][value=${id}]`);
                        $checkbox.prop('checked', !$checkbox.is(':checked'));
                        $keywords.find(`option[value="condition\:${id}"]`).remove();
                        showClearFilter();
                        break;
                    case 'propertyType':
                        urlBuilder.updateArrayBaseFilter("propertytype",id);
                        Livewire.dispatch('propertyTypeFilterChanged', {propertyTypeSlug: id});
                        $checkbox = $(`input[name=property_types\\[\\]][value=${id}]`);
                        $checkbox.prop('checked', !$checkbox.is(':checked'));
                        $keywords.find(`option[value="propertyType\:${id}"]`).remove();
                        showClearFilter();
                        break;
                    case 'idealFor':
                        urlBuilder.updateArrayBaseFilter("ideal",id);
                        Livewire.dispatch('idealForFilterChanged', {idealForSlug: id});
                        $checkbox = $(`input[name=ideal_for\\[\\]][value=${id}]`);
                        $checkbox.prop('checked', !$checkbox.is(':checked'));
                        $keywords.find(`option[value="idealFor\:${id}"]`).remove();
                        showClearFilter();
                        break;
                    case 'amenity':
                        urlBuilder.updateArrayBaseFilter("amenity",id);
                        Livewire.dispatch('amenityFilterChanged', {amenityId: id});
                        $checkbox = $amenityFilters.find(`input[type=checkbox][value=${id}]`);
                        $checkbox.prop('checked', !$checkbox.is(':checked'));
                        $keywords.find(`option[value="amenity\:${id}"]`).remove();
                        showClearFilter();
                        break;


                }
            }else{
                switch (type) {
                    case "hasElevator":
                        console.log("clear elevator");
                        urlBuilder.updateArrayBaseFilter("hasElevator","",false);
                        Livewire.dispatch('hasElevatorFilterChanged', {hasElevator: null});
                        $hasElevatorFilter.prop("checked",'');
                        $keywords.find(`option[value="hasElevator"]`).remove();
                        showClearFilter();
                        break;
                    /*case "onSale":
                        console.log("RUN HERE!!!!!");
                        urlBuilder.updateArrayBaseFilter("onSale","",false);
                        Livewire.dispatch('onSaleFilterChange', null);
                        $onSaleFilter.prop("checked",'');
                        $keywords.find(`option[value="onSale"]`).remove();
                        showClearFilter();
                        break;
                    */
                    case "bathrooms":
                        console.log("bath emitted");
                        urlBuilder.updateArrayBaseFilter("bathrooms","",false);
                        Livewire.dispatch('bathroomsFilterChanged', {bathroomsExpression: null});
                        $bathroomsFilter.find('input[type=radio]').prop("checked",'');
                        $keywords.find(`option[value="bathRooms"]`).remove();
                        showClearFilter();
                        break;
                    case "rental":
                        console.log("rental emitted");
                        urlBuilder.updateArrayBaseFilter("rental","",false);
                        Livewire.dispatch('rentalTypeFilterChanged', {rental: null});
                        $rentalFilters.find('input[type=radio]').prop("checked",'');
                        $keywords.find(`option[value="rental"]`).remove();
                        showClearFilter();
                        break;
                    case "is_sold":
                        console.log("is_sold emitted");
                        urlBuilder.updateArrayBaseFilter("is_sold","",false);
                        Livewire.dispatch('isSoldFilterChanged', {isSold: null});
                        $isSoldFilters.find('input[type=radio]').prop("checked",'');
                        $keywords.find(`option[value="is_sold"]`).remove();
                        showClearFilter();
                        break;
                    case 'minPrice':
                        $minPriceFilter.val("");
                        $minPriceFilterMobile.val("");
                        emitPriceFilterChange();
                        break;
                    case 'maxPrice':
                        $maxPriceFilter.val("");
                        $maxPriceFilterMobile.val("");
                        emitPriceFilterChange();
                        break;
                    case 'minSize':
                        $minSizeFilter.val("");
                        $minSizeFilterMobile.val("");
                        emitSizeFilterChange();
                        break;
                    case 'maxSize':
                        $maxSizeFilter.val("");
                        $maxSizeFilterMobile.val("");
                        emitSizeFilterChange();
                        break;
                    case 'minRoom':
                        $minRoomFilter.val("");
                        $minRoomFilterMobile.val("");
                        emitRoomFilterChange();
                        break;
                    case 'maxRoom':
                        $maxRoomFilter.val("");
                        $maxRoomFilterMobile.val("");
                        emitRoomFilterChange();
                        break;
                    default:
                        if(e.type === "select2:select"){
                            Livewire.dispatch('filterApartmentName', {name: e.params.data.text});
                            urlBuilder.updateArrayBaseFilter("name",e.params.data.text,false);
                            showClearFilter();
                            Object.values($keywords.children()).map(option => {
                                const $selectedOption = typeof option === "object" ? $(option) : null;
                                if(!!$selectedOption &&  $selectedOption.length  && !!$selectedOption.val() && !!$selectedOption.html() && $selectedOption.val() !== e.params.data.id && $selectedOption.val() === $selectedOption.html()){
                                    $selectedOption.remove();
                                    $keywords.trigger('change');
                                }
                            });

                        }else{
                            Livewire.dispatch('filterApartmentName', {name: null});
                            urlBuilder.updateArrayBaseFilter("name","",false);
                        }
                        break;

                }
            }

        };

        $keywords.select2({
            ajax: {
                url: lookupUrl,
                dataType: 'json',
                delay: 200,
                processResults: data => {

                    const results = [];

                    if (data.amenities) {

                        data.amenities.forEach(amenity => results.push({
                            id: 'amenity:' + amenity.id,
                            text: amenity.name
                        }))
                    }

                    if (data.districts) {

                        data.districts.forEach(district => results.push({
                            id: 'district:' + district.id,
                            text: district.name
                        }))
                    }

                    if(data.bedrooms){
                        data.bedrooms.forEach(bedrooms => results.push({
                            id: 'bedrooms:' + bedrooms.id,
                            text: bedrooms.name
                        }))
                    }

                    return {results};
                }
            },
            allowClear: false,
            tags:true,
            closeOnSelect: true,
            multiple: true,
            minimumInputLength: 2,
            language: {
                locale,
                inputTooShort: function(args) {
                    return "";
                }
            },
            placeholder: keywordsPlaceholder,
            templateSelection: selection => {
                return selection.text;
            },
            templateResult: data => {
                return $(`
                    <div class="d-flex">
                        ${data.text}
                    </div>
                `);
            }
        })
            .on('select2:select', toggleSearchableComponent)
            .on('select2:unselect', toggleSearchableComponent)

        ;

        const initFilters = () => {
            if(!!initFiltersContent && Object.keys(initFiltersContent).length > 0){
                Object.entries(initFiltersContent).map((keyValue) => {
                    const key = keyValue[0];
                    const value = keyValue[1];
                    /*console.log("runehere",key,value);*/
                    switch (key) {
                        case "districts":
                            value.map((id) => showAtInitFilterArrayItem(key,id,"district"));
                            break;
                        case "bedrooms":
                            /*console.log("bedroom",value)*/
                            value.map((id) => showAtInitFilterArrayItem("bedrooms",id));
                            break;
                        case "view":
                            value.map((id) => showAtInitFilterArrayItem("views",id,"view"));
                            break;
                        case "buildingType":
                            value.map((id) => showAtInitFilterArrayItem("buildingTypes",id,"buildingType"));
                            break;
                        case "condition":
                            value.map((id) => showAtInitFilterArrayItem("conditions",id,"condition"));
                            break;
                        case "propertytype":
                            /*console.log("property type ?!",value);*/
                            value.map((id) => showAtInitFilterArrayItem("property_types",id,"propertyType"));
                            break;
                        case "ideal":
                            value.map((id) => showAtInitFilterArrayItem("ideal_for",id,"idealFor"));
                            break;
                        case "amenity":
                            value.map((id) => showAtInitFilterArrayItem(key,id));
                            break;
                        case "bathrooms":
                            $bathroomsFilter.find(`input[type=radio][value=${value}]`).prop("checked",'checked');
                            addSelectOption(`bathrooms`, $bathroomsFilter.prev().text());
                            break;
                        case "rental":
                            $rentalFilters.find(`input[type=radio][value=${value}]`).prop("checked",'checked');
                            addSelectOption(`rental`, value == 1 ? $('#forRentalText').text() : $('#forSaleText').text());
                            break;
                        case "is_sold":
                            $isSoldFilters.find(`input[type=radio][value=${value}]`).prop("checked",'checked');
                            addSelectOption(`is_sold`, value == 1 ? $('#forIsSoldText').text() : $('#forSaleText').text());
                            break;
                        case "hasElevator":
                            $hasElevatorFilter.prop("checked",'checked');
                            addSelectOption(`hasElevator`,`Has elevator`);
                            break;
                        /*case "onSale":
                            console.log("onSale");
                            $onSaleFilter.prop("checked",'checked');
                            addSelectOption(`onSale`,`On Sale`);
                            break;
                        */
                        case "minPriceFilter":
                            $minPriceFilter.val(value);
                            $minPriceFilterMobile.val(value);
                            const minText = $minPriceFilter.parent().parent().find("span").html();
                            addSelectOption(`minPrice`,minText+value);
                            break;
                        case "maxPriceFilter":
                            $maxPriceFilter.val(value);
                            $maxPriceFilterMobile.val(value);
                            const maxText = $maxPriceFilter.parent().parent().find("span").html();
                            addSelectOption(`maxPrice`,maxText+value);
                            break;
                        case "minSizeFilter":
                            $minSizeFilter.val(value);
                            $minSizeFilterMobile.val(value);
                            addSelectOption(`minSize`,$minSizeFilter.parent().parent().find("span").html() + value);
                            break;
                        case "maxSizeFilter":
                            $maxSizeFilter.val(value);
                            $maxSizeFilterMobile.val(value);
                            addSelectOption(`maxSize`,$maxSizeFilter.parent().parent().find("span").html() + value);
                            break;
                        case "minRoomFilter":
                            $minRoomFilter.val(value);
                            $minRoomFilterMobile.val(value);
                            addSelectOption(`minRoom`,$minRoomFilter.parent().parent().find("span").html() + value);
                            break;
                        case "maxRoomFilter":
                            $maxRoomFilter.val(value);
                            $maxRoomFilterMobile.val(value);
                            addSelectOption(`maxRoom`,$maxRoomFilter.parent().parent().find("span").html() + value);
                            break;
                        case "name":
                            addSelectOption(value,value);
                            break;


                    }
                });
                showClearFilter();

            }
        };



        const addSelectOption = (value,content) => {
            console.log($keywords.children());
            let $option = $(`<option value="${value}" selected="selected">${content}</option>`);
            $keywords.append($option);
            $keywords.trigger('change');
        };

        initFilters();




        const optimizeNumericFilterAmount = (amount) => amount === '' ? null : parseInt(amount);
        const emitPriceFilterChange = () => {

            const minPriceVal = $minPriceFilter.val().trim();
            const maxPriceVal = $maxPriceFilter.val().trim();
            urlBuilder.updateArrayBaseFilter("minPriceFilter",minPriceVal,false);
            urlBuilder.updateArrayBaseFilter("maxPriceFilter",maxPriceVal,false);
            const minText = $minPriceFilter.parent().parent().find("span").html();
            const maxText = $maxPriceFilter.parent().parent().find("span").html();
            let $minOption = $keywords.find(`option[value="minPrice"]`);
            if ($minOption.length) {

                $minOption.remove();
            }
            if(minPriceVal !== ""){
                $minOption = $(`<option value="minPrice" selected="selected">${minText} ${minPriceVal}</option>`);
                $keywords.append($minOption);
            }

            let $maxOption = $keywords.find(`option[value="maxPrice"]`);
            if ($maxOption.length) {

                $maxOption.remove();
            }
            if(maxPriceVal !== ""){
                $maxOption = $(`<option value="maxPrice" selected="selected">${maxText} ${maxPriceVal}</option>`);
                $keywords.append($maxOption);
            }

            showClearFilter();
            Livewire.dispatch(
                'priceFilterChanged',
                {
                    min: optimizeNumericFilterAmount(minPriceVal),
                    max: optimizeNumericFilterAmount(maxPriceVal)
                }
            )
        };
        const emitSizeFilterChange = () => {

            let minSizeValue = $minSizeFilter.val().trim();
            let maxSizeValue = $maxSizeFilter.val().trim();
            urlBuilder.updateArrayBaseFilter("minSizeFilter",minSizeValue,false);
            urlBuilder.updateArrayBaseFilter("maxSizeFilter",maxSizeValue,false);
            const minText = $minSizeFilter.parent().parent().find("span").html();
            const maxText = $maxSizeFilter.parent().parent().find("span").html();
            let $minOption = $keywords.find(`option[value="minSize"]`);
            if ($minOption.length) {

                $minOption.remove();
            }
            if(minSizeValue !== ""){
                $minOption = $(`<option value="minSize" selected="selected">${minText} ${minSizeValue}</option>`);
                $keywords.append($minOption);
            }

            let $maxOption = $keywords.find(`option[value="maxSize"]`);
            if ($maxOption.length) {

                $maxOption.remove();
            }
            if(maxSizeValue !== ""){
                $maxOption = $(`<option value="maxSize" selected="selected">${maxText} ${maxSizeValue}</option>`);
                $keywords.append($maxOption);
            }
            showClearFilter();
            return Livewire.dispatch(
                'sizeFilterChanged',
                {
                    min: optimizeNumericFilterAmount(minSizeValue),
                    max: optimizeNumericFilterAmount(maxSizeValue)
                }
            )
        };

        const emitRoomFilterChange = () => {

            let minRoomValue = $minRoomFilter.val().trim();
            let maxRoomValue = $maxRoomFilter.val().trim();
            urlBuilder.updateArrayBaseFilter("minRoomFilter",minRoomValue,false);
            urlBuilder.updateArrayBaseFilter("maxRoomFilter",maxRoomValue,false);
            const minText = $minRoomFilter.parent().parent().find("span").html();
            const maxText = $maxRoomFilter.parent().parent().find("span").html();
            let $minOption = $keywords.find(`option[value="minRoom"]`);
            if ($minOption.length) {
                $minOption.remove();
            }
            if(minRoomValue !== ""){
                $minOption = $(`<option value="minRoom" selected="selected">${minText} ${minRoomValue}</option>`);
                $keywords.append($minOption);
            }
            let $maxOption = $keywords.find(`option[value="maxRoom"]`);
            if ($maxOption.length) {
                $maxOption.remove();
            }
            if(maxRoomValue !== ""){
                $maxOption = $(`<option value="maxRoom" selected="selected">${maxText} ${maxRoomValue}</option>`);
                $keywords.append($maxOption);
            }
            showClearFilter();
            return Livewire.dispatch(
                'roomFilterChanged',
                {
                    min: optimizeNumericFilterAmount(minRoomValue),
                    max: optimizeNumericFilterAmount(maxRoomValue)
                }
            )
        };

        const debounce = ($e, amount, fn) => {

            if ($e.data('__debounceTimeout')) {
                clearTimeout($e.data('__debounceTimeout'));
            }

            $e.data('__debounceTimeout', setTimeout(fn, amount));
        };

        $minPriceFilterMobile.on('change keydown', (e) => {
            $minPriceFilter.val($minPriceFilterMobile.val());
            if (e.type === 'keydown') {
                debounce($minPriceFilter, 500, emitPriceFilterChange);
            } else {
                emitPriceFilterChange();
            }

        });
        $minPriceFilter.on('change keydown', (e) => {
            $minPriceFilterMobile.val($minPriceFilter.val());
            if (e.type === 'keydown') {
                debounce($minPriceFilter, 500, emitPriceFilterChange)
            } else {
                emitPriceFilterChange()
            }
        });

        $maxPriceFilter.on('change keydown', (e) => {
            $maxPriceFilterMobile.val($maxPriceFilter.val());
            if (e.type === 'keydown') {
                debounce($maxPriceFilter, 500, emitPriceFilterChange)
            } else {
                emitPriceFilterChange()
            }
        });

        $maxPriceFilterMobile.on('change keydown', (e) => {
            $maxPriceFilter.val($maxPriceFilterMobile.val());
            if (e.type === 'keydown') {
                debounce($maxPriceFilter, 500, emitPriceFilterChange)
            } else {
                emitPriceFilterChange()
            }
        });
    /*
        $minSizeFilter.on('change keydown', (e) => e.type === 'keydown'
            ? debounce($minSizeFilter, 500, emitSizeFilterChange)
            : emitSizeFilterChange()
        );

        $maxSizeFilter.on('change keydown', (e) => e.type === 'keydown'
            ? debounce($maxSizeFilter, 500, emitSizeFilterChange)
            : emitSizeFilterChange()
        );*/

        $minSizeFilter.on('change keydown', (e) => {
            $minSizeFilterMobile.val($minSizeFilter.val());
            if (e.type === 'keydown') {
                debounce($minSizeFilter, 500, emitSizeFilterChange)
            } else {
                emitSizeFilterChange()
            }
        })

        $minSizeFilterMobile.on('change keydown', (e) => {
            console.log("min size fix",e.type);
            $minSizeFilter.val($minSizeFilterMobile.val());
            if (e.type === 'keydown') {
                debounce($minSizeFilter, 500, emitSizeFilterChange)
            } else {
                emitSizeFilterChange()
            }
        })

        $maxSizeFilter.on('change keydown', (e) => {
            $maxSizeFilterMobile.val($maxSizeFilter.val());
            if (e.type === 'keydown') {
                debounce($maxSizeFilter, 500, emitSizeFilterChange)
            } else {
                emitSizeFilterChange()
            }
        })

        $maxSizeFilterMobile.on('change keydown', (e) => {
            $maxSizeFilter.val($maxSizeFilterMobile.val());
            if (e.type === 'keydown') {
                debounce($maxSizeFilter, 500, emitSizeFilterChange)
            } else {
                emitSizeFilterChange()
            }
        })

        $minRoomFilter.on('change keydown', (e) => {
            $minRoomFilter.val($minRoomFilter.val());
            if (e.type === 'keydown') {
                debounce($minRoomFilter, 500, emitRoomFilterChange)
            } else {
                emitRoomFilterChange()
            }
        })

        $maxRoomFilter.on('change keydown', (e) => {
            $maxRoomFilter.val($maxRoomFilter.val());
            if (e.type === 'keydown') {
                debounce($maxRoomFilter, 500, emitRoomFilterChange)
            } else {
                emitRoomFilterChange()
            }
        })

        $minRoomFilterMobile.on('change keydown', (e) => {
            $minRoomFilter.val($minRoomFilterMobile.val());
            if (e.type === 'keydown') {
                debounce($minRoomFilter, 500, emitRoomFilterChange)
            } else {
                emitRoomFilterChange()
            }
        })

        $maxRoomFilterMobile.on('change keydown', (e) => {
            $maxRoomFilter.val($maxRoomFilterMobile.val());
            if (e.type === 'keydown') {
                debounce($maxRoomFilter, 500, emitRoomFilterChange)
            } else {
                emitRoomFilterChange()
            }
        })

        $bathroomsFilter.find('input[type=radio]').on('change', function () {
            urlBuilder.updateArrayBaseFilter("bathrooms",$(this).val(),false);

            let $option = $keywords.find(`option[value="bathRooms"]`);

            if ($option.length) {
                $option.remove();
            }
            $option = $(`<option value="bathRooms" selected="selected">${$(this).prev().text()}</option>`);
            $keywords.append($option);

            Livewire.dispatch('bathroomsFilterChanged', {bathroomsExpression: $(this).val()});
            showClearFilter();
        });

        $rentalFilters.find('input[type=radio]').on('change', function () {
            urlBuilder.updateArrayBaseFilter("rental" ,$(this).val(), false);
            let $option = $keywords.find(`option[value="rental"]`);
            if ($option.length) {
                $option.remove();
            }
            $option = $(`<option value="rental" selected="selected">${$(this).prev().text()}</option>`);
            $keywords.append($option);

            Livewire.dispatch('rentalTypeFilterChanged', {rental: $(this).val()});
            showClearFilter();
        });

        $isSoldFilters.find('input[type=radio]').on('change', function () {
            urlBuilder.updateArrayBaseFilter("is_sold" ,$(this).val(), false);
            let $option = $keywords.find(`option[value="is_sold"]`);
            if ($option.length) {
                $option.remove();
            }
            $option = $(`<option value="is_sold" selected="selected">${$(this).prev().text()}</option>`);
            $keywords.append($option);

            Livewire.dispatch('isSoldFilterChanged', {isSold: $(this).val()});
            showClearFilter();
        });

        $('input[name=districts\\[\\]]').on('change', function () {
            const id = $(this).val();
            urlBuilder.updateArrayBaseFilter("districts",id);
            Livewire.dispatch('districtFilterChanged', {district: $(this).val()});

            let $option = $keywords.find(`option[value="district\:${id}"]`);

            if ($option.length) {

                $option.remove();
            } else {

                $option = $(`<option value="district:${id}" selected="selected">${$(this).prev().text()}</option>`);
                $keywords.append($option);
            }

            $keywords.trigger('change');
            showClearFilter();
        });

        $('input[name=bedrooms\\[\\]]').on('change', function () {
            const id = $(this).val();

            urlBuilder.updateArrayBaseFilter("bedrooms",id);
            Livewire.dispatch('bedroomsFilterChange', {bedroomsType: $(this).val()});

            let $option = $keywords.find(`option[value="bedrooms\:${id}"]`);

            if ($option.length) {
                $option.remove();
            } else {
                $option = $(`<option value="bedrooms:${id}" selected="selected">${$(this).prev().text()}</option>`);
                $keywords.append($option);
            }
            $keywords.trigger('change');
            showClearFilter();
        });

        $viewFilters.find('input[type=checkbox]').on('change', function () {
            const id = $(this).val();
            urlBuilder.updateArrayBaseFilter("view",id);
            let $option = $keywords.find(`option[value="view\:${id}"]`);
            if ($option.length) {
                $option.remove();
            } else {
                $option = $(`<option value="view:${id}" selected="selected">${$(this).prev().text()}</option>`);
                $keywords.append($option);
            }
            Livewire.dispatch('viewFilterChanged', {viewSlug: id});
            showClearFilter();
        });

        $buildingTypeFilters.find('input[type=checkbox]').on('change', function () {
            console.log("change ?!?! ");
            const id = $(this).val();
            urlBuilder.updateArrayBaseFilter("buildingType",id);
            let $option = $keywords.find(`option[value="buildingType\:${id}"]`);
            if ($option.length) {
                $option.remove();
            } else {
                $option = $(`<option value="buildingType:${id}" selected="selected">${$(this).prev().text()}</option>`);
                $keywords.append($option);
            }
            Livewire.dispatch('buildingTypeFilterChanged', {typeName: id});
            showClearFilter();
        });

        $conditionFilters.find('input[type=checkbox]').on('change', function () {
            const id = $(this).val();
            urlBuilder.updateArrayBaseFilter("condition",id);
            let $option = $keywords.find(`option[value="condition\:${id}"]`);

            if ($option.length) {
                $option.remove();
            } else {
                $option = $(`<option value="condition:${id}" selected="selected">${$(this).prev().text()}</option>`);
                $keywords.append($option);
            }
            Livewire.dispatch('conditionFilterChanged', {conditionSlug: id});
            showClearFilter();
        });

        $propertyTypeFilters.find('input[type=checkbox]').on('change', function () {
            const id = $(this).val();
            urlBuilder.updateArrayBaseFilter("propertytype",id);
            let $option = $keywords.find(`option[value="propertyType\:${id}"]`);

            if ($option.length) {
                $option.remove();
            } else {
                $option = $(`<option value="propertyType:${id}" selected="selected">${$(this).prev().text()}</option>`);
                $keywords.append($option);
            }
            Livewire.dispatch('propertyTypeFilterChanged', {propertyTypeSlug: id});
            showClearFilter();
        });

        $idealForFilters.find('input[type=checkbox]').on('change', function () {
            const id = $(this).val();
            urlBuilder.updateArrayBaseFilter("ideal",id);
            let $option = $keywords.find(`option[value="idealFor\:${id}"]`);
            if ($option.length) {
                $option.remove();
            } else {
                $option = $(`<option value="idealFor:${id}" selected="selected">${$(this).prev().text()}</option>`);
                $keywords.append($option);
            }
            Livewire.dispatch('idealForFilterChanged', {idealForSlug: id});
            showClearFilter();
        });

        $amenityFilters.find('input[type=checkbox]').on('change', function () {

            const id = $(this).val();
            urlBuilder.updateArrayBaseFilter("amenity",id);
            Livewire.dispatch('amenityFilterChanged', {amenityId: id});

            let $option = $keywords.find(`option[value="amenity\:${id}"]`);

            if ($option.length) {

                $option.remove();
            } else {

                $option = $(`<option value="amenity:${id}" selected="selected">${$(this).prev().text()}</option>`);
                $keywords.append($option);
            }

            $keywords.trigger('change');

            showClearFilter();
        });
        /*$onSaleFilter.on('change', function(){
            const checked = $(this).is(':checked');
            $onSaleFilter.prop('checked',checked ? 'checked' : "");
            urlBuilder.updateArrayBaseFilter("onSale",!!checked ? checked : "",false);
            showClearFilter();
            let $option = $keywords.find(`option[value="onSale"]`);
            console.log("chekced? ",checked," on-sale option?", $option.length);
            if ($option.length) {
                $option.remove();
            } else {
                if(checked){
                    $option = $(`<option value="onSale" selected="selected">${$(this).prev().text()}</option>`);
                    $keywords.append($option);
                }
            }
            Livewire.dispatch('onSaleFilterChange',!!checked ? checked : null );
        });
        */
        $hasElevatorFilter.on('change', function(e) {

            const checked = $(e.target).is(':checked');
            $hasElevatorFilter.prop('checked',checked ? 'checked' : "");
            console.log("111111 checked value has elevetor",checked,e.target);
            urlBuilder.updateArrayBaseFilter("hasElevator",!!checked ? checked : "",false);
            showClearFilter();
            let $option = $keywords.find(`option[value="hasElevator"]`);

            if ($option.length) {
                $option.remove();
            } else {
                if(checked){
                    $option = $(`<option value="hasElevator" selected="selected">Has elevator</option>`);
                    $keywords.append($option);
                }
            }


            console.log("checked value has elevetor",checked,"option length",$option);

            Livewire.dispatch('hasElevatorFilterChanged', {hasElevator: checked});
        });


        $(document).bind('mouseup touchend', function (e) {
            var container = $('#sort-select-div');
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $('.options').addClass('options--fade-out');
                $('#sort-select-div .select').removeClass('hover');
            }
        });
        body.on('click', '#sort-select-div', function () {
            $('.options').toggleClass('options--fade-out');
            $(this).toggleClass("pushed")
        });

        /*body.on('mouseleave', '.buy-dropdown__menu', function () {
            console.log("run here?");
            $(this).prev(".buy-dropdown__button").toggleClass("buy-dropdown__button_active");
            $(this).toggleClass("d-block")
        });*/

        body.on("click",function(e){
            var clickedOn = $(e.target);
            if ( clickedOn.is('.buy-dropdown__menu') || clickedOn.parents().is('.buy-dropdown__menu') || clickedOn.is('.buy-dropdown__button') || clickedOn.parent().is('.buy-dropdown__button')){
                //console.log( "Clicked on", clickedOn[0], "inside the div" );
            }else{
                removeAllActiveFilter(null);

            }
        });

        body.on('click', '.buy-dropdown__button', function () {
            removeAllActiveFilter(this);
            $(this).toggleClass("buy-dropdown__button_active");
            $(this).next(".buy-dropdown__menu").toggleClass("d-block")
        });

        body
            .on('click', '#sort-select-div .options li', function (e) {
                if (!$(this).hasClass("disabled")) {
                    let value = $(this).data("value");
                    let content = $(this).html();

                    $(".select .label").html(content);

                    const $select = $('#sort-select');

                    $select.val(value);

                    $select[0].dispatchEvent(new Event('change'));

                } else {
                    e.stopPropagation();
                }
            });

        //$(`#sort-select-div .select label`).html($(`#sort-select-div .select label`).data("default"));

        body.on("click", "#map-show-switch", function () {
            $(".js-images-wrapper").toggleClass("map-shown");
            $(".acf-map").toggleClass("map-shown");
        });
        body.on("click", "#map-close", function () {
            $(".js-images-wrapper").toggleClass("map-shown");
            $(".acf-map").toggleClass("map-shown");
        });

        body.on("click", "#mobile-filter-open", function (e) {
            e.preventDefault();
            mobileFilterInit();
        });

        body.on("click", "#search-on-mobile", function (e) {
            e.preventDefault();

            mobileFilterInit();
        });

        let mobileFilterInit = () => {
            $("#mobile-filter-container").addClass("show");
            /* Check navigation menu is active */
            var navbarMenuButton = $("#navbar-menu-button");
            if (!navbarMenuButton.hasClass("collapsed")) {
                navbarMenuButton.trigger("click");
            }
        };
        body.on('click', "#close-filter-menu-button", function () {
            $("#mobile-filter-container").removeClass("show");
        });
        body.on('click', "#mobile-search-button", function () {
            $("#mobile-filter-container").removeClass("show");
        });

        body.on('click', '.select-filter-first-element', function () {
            let index = $(this).data("index");
            $("#mobile-filter-container").removeClass("show");
            $("#mobile-filter-second-container").addClass("show");
            $(".filter-second-section-content-" + index).removeClass("d-none");
            $("#back-filter-menu-button").removeClass("d-none");
        });

        body.on('click', '.back-filter-menu-button', function () {
            $("#mobile-filter-second-container").removeClass("show");
            $("#mobile-filter-container").addClass("show");
            $(".filter-second-section-content").addClass("d-none");
            $("#back-filter-menu-button").addClass("d-none");
        });

        window.addEventListener('popstate', function (event) {
            this.location.reload();
        });

        // Google maps.
        const $mapsContainer = $('#buyApartmentMap');
        const initMap = () => {
            checkShowToResolution();
            const finalClusterImage = clusterImage;
            const map = new google.maps.Map($mapsContainer[0], {
                center: new google.maps.LatLng(47.502002, 19.043150),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                zoomControl: true,
                zoomControlOptions: {position: google.maps.ControlPosition.LEFT_TOP},
                styles: [{featureType: "poi", stylers: [{visibility: "off"}]}],
                disableDefaultUI: !0,
                zoom: 9
            });

            const markers = JSON.parse($mapsContainer.attr('data-apartments'))
                .map(data => {
                    //console.log("SOLD?! ",data.sold);
                    const info = `<div class="info-window">
                        <div class="info-window__close">&#10005;</div>
                        ${data.sold ? '<span class="sold-map-text">SOLD</span>' : ""}
                        <a href="${data.link}"><div class="info-window__image" style="background-image: url(${data.thumbnailUrl})"></div></a>
                        <div class="info-window__lower-section c-grey0"><p class="info-window__street-name font-sm font-md circularstd-bold c-black">${data.title}</p>
                        <p class="info-window__district-name font-xs circularstd-book c-grey">${data.district_name}</p>
                        <h5 class="info-window__prize font-sm circularstd-book c-black m-0">
                          ${data.symbol}   ${data.price}
                        </h5>
                            <div class="d-flex flex-wrap font-12 circularstd-book c-black">
                                ${data.approx_sqm}   sqm &nbsp;
                                ${data.bedrooms} bedroom &nbsp;&nbsp;
                                ${data.bathrooms}  bath &nbsp;
                            </div>
                            <div class="text-center">
                                <div class="marker__triangle"></div>
                            </div>
                        </div>`;
                    const infoWindow = new google.maps.InfoWindow({
                        content: info,
                        maxWidth: 380,
                        pixelOffset: new google.maps.Size(10, 30)
                    });

                    const marker = new google.maps.Marker({
                        icon: `${mapMarkerImage}`,
                        position: {
                            lat: parseFloat(data.lat),
                            lng: parseFloat(data.lng)
                        },
                        infoWindow: infoWindow,

                    });

                    google.maps.event.addListener(marker, 'click', function () {
                        markers.forEach(marker => marker.infoWindow.close());
                        marker.infoWindow.open(map, marker);
                    });

                    return marker;
                });

            new MarkerClusterer(
                map,
                markers, {
                    imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                    styles: [{
                        url: `${finalClusterImage}`,
                        height: 40,
                        width: 40,
                        textColor: "#ffffff",
                        textSize: 16,
                        fontFamily: "circularstd_book",
                        fontWeight: "normal"
                    }, {
                        url: `${finalClusterImage}`,
                        height: 60,
                        width: 60,
                        textColor: "#ffffff",
                        textSize: 16,
                        fontFamily: "circularstd_book",
                        fontWeight: "normal"
                    }, {
                        url: `${finalClusterImage}`,
                        height: 90,
                        width: 90,
                        textColor: "#ffffff",
                        textSize: 16,
                        fontFamily: "circularstd_book",
                        fontWeight: "normal"
                    }, {
                        url: `${finalClusterImage}`,
                        height: 120,
                        width: 120,
                        textColor: "#ffffff",
                        textSize: 16,
                        fontFamily: "circularstd_book",
                        fontWeight: "normal"
                    }, {
                        url: `${finalClusterImage}`,
                        height: 150,
                        width: 150,
                        textColor: "#ffffff",
                        textSize: 16,
                        fontFamily: "circularstd_book",
                        fontWeight: "normal"
                    }]
                });
        };

        // Recreate google maps stuff.
        Livewire.on('apartmentListUpdated', () => {
            setTimeout(initMap, 1);
        });

        initMap();

        checkPlaceholder();

        window.onresize = () => checkPlaceholder();
    });

});

function removeAllActiveFilter(current) {
    $(".buy-dropdown__button_active").each(function () {
        if (this !== current) {
            $(this).next(".buy-dropdown__menu").removeClass("d-block")
            $(this).removeClass("buy-dropdown__button_active");
        }
    });
}

function checkPlaceholder(){
    if ($("body").width() <= 992) {
        $(".select2-search__field").attr("placeholder",$keywords.data("mobile-placeholder"));
    }else{
        $(".select2-search__field").attr("placeholder",$keywords.data("desktop-placeholder"));
    }
}

function checkShowToResolution(){
    const $mainLoader = $("#main-loader");
    const $mainContainer = $("#main-container");
    const $containerFluid = $("#container-fluid");

    /* Check body width */
    if ($("body").width() <= 992) {
        $(".acf-map").removeClass("map-shown");
        $(".js-images-wrapper").removeClass("map-shown");
        setTimeout(() => {
            $mainLoader.addClass("d-none");
            $mainContainer.removeClass("d-none");
            $containerFluid.removeClass("p-0");
        },1)
    } else {
        $(".acf-map").addClass("map-shown");
        $(".js-images-wrapper").addClass("map-shown");
        setTimeout(() => {
            $mainLoader.addClass("d-none");
            $mainContainer.removeClass("d-none");
            $containerFluid.removeClass("p-0");
        },1)
    };
}
